<template lang="pug">
	div(id="kt-chat" :class="d_connected===false ? 'not-connected':null")
		div(id="side-nav-controls")
			b-dropdown(right dropup no-caret :variant="d_connected===false ?'outline-secondary':'outline-primary'")
				div
					b-button(class="btn-start-new-chat" variant="outline-primary"  @click="m_startNewChat" :disabled="!d_connected")
						fa-icon(icon="comment-dots")
						|  Start New Chat
				div(class="chats")
					div(class="no-connection" v-if="d_connected===false") 
						fa-icon(icon="exclamation-triangle")
						div Team Chat is Currently Unavailable
						span(class="btn btn-link" @click="m_tryReconn") Try to re-connect
					div(class="chat" v-for="c in d_chats.filter(x=> x.isHost || x.messages.length>0)" :key="c.chatId"
						:class="c.fn_isOpen() ? 'open': null")
						div(@click="m_openChat($event, c)")
							div
								img(:src="c.fn_img()")
							div
								span {{c.fn_lbl()}}
								span {{c.chatTitle||"No Chat Topic"}}
						span(class="new-msgs kt-bbl" v-show="c.newMsgCnt") {{c.newMsgCnt}}
					div(class="no-chats" v-if="d_chats.length == 0") You currently don't have any chats
		
				template(v-slot:button-content)
					fa-icon(icon="comments")
					span Team Chat
			span(ref="notification" class="notification" v-show="c_newMsgCnt" ) {{c_newMsgCnt}}
			span(class="no-connection" v-if="d_connected===false" v-b-tooltip.hover.topright.ds700="'Team Chat Unavailable'")
				fa-icon(icon="exclamation-triangle")
		div(id="kt-chat-main" ref="kt-chat-main" v-if="d_chatCrnt.chatId" :class="d_chatCrnt.fn_class()"
			:style="{width:d_chatCrnt.dim.W, height:d_chatCrnt.dim.H}")
			vue-quick-chat(
				:participants="d_chatCrnt.participants"
				:myself="d_chatCrnt.myself"
				:messages="d_chatCrnt.messages"
				:colors="d_dfltCP.colors"
				:profile-picture-config="d_dfltCP.profilePictureConfig"
				:timestamp-config="d_dfltCP.timestampConfig"
				placeholder="Enter message"
				:submit-icon-size="20",
				:submit-image-icon-size="20"
				:send-images="false"
				@onMessageSubmit="m_sendMessage"
			)
				template(v-slot:header)
					div(class="title")
						b-form-input(v-model="d_chatCrnt.chatTitle" :disabled="!d_chatCrnt.isHost" maxlength="100"
							:placeholder="d_chatCrnt.isHost? 'Enter Chat Topic (Optional)':'No Chat Topic'" @change="m_changeTitle")
					div(class="buttons")
						b-button(variant="none" v-b-tooltip.hover.top.ds700="'Hide Chat'" @click="m_hideChat")
							fa-icon(icon="minus")
						b-button(variant="none" v-b-tooltip.hover.top.ds700="'Leave and Delete Chat'" @click="m_deleteChat")
							fa-icon(icon="times")
					
					div(class="participants" title="Chat Participants")
						span
							span You{{(d_chatCrnt.isHost? '(host)': '')}}
						span(v-for="p in c_participants" :key="p.id")
							span {{p.name + (p.isHost? ' (host)': '')}}
							b-button(v-if="d_chatCrnt.isHost" class="btn-remove" variant="none" @click="m_removeParticipant(p)"
								v-b-tooltip.hover.auto.ds500="'Remove Participant'")
								fa-icon(icon="times")
						kt-select(v-if="d_chatCrnt.isHost" id="kt-chat-add-participant" ref="kt-select-participant"
							p_appEntKey="team" p_noIcon=true
							p_filterKey="appUsers" p_placeholder="Search/Add Team Member(s)"
							@change="m_addParticipant"
						)
					div(class="related-record" title="Related Record")
						span(v-if="d_chatCrnt.isHost && !d_chatCrnt.relatedRecord" class="btn-add-related btn btn-link" @click="m_addRelated") Add Related Record
						div(v-if="d_chatCrnt.relatedRecord")
							router-link(:to="d_chatCrnt.relatedRecord.href") {{d_chatCrnt.relatedRecord.label}}
							b-button(v-if="d_chatCrnt.isHost" class="btn-remove" variant="none" @click="d_chatCrnt.relatedRecord=null; m_changeRelated()"
								v-b-tooltip.hover.auto.ds500="'Remove Related Record'")
								fa-icon(icon="times")
			div(class="resizer" @mousedown="m_resizeChat($event)" title="Resize")
				fa-icon(icon="chevron-right")
		b-modal(id="bm-kt-chat-related" size="md" hide-header cancel-variant="outline-secondary"
			centered no-fade no-close-on-backdrop ok-title="Relate to Chat" :ok-disabled="d_okDisabled" @ok="m_addRelatedOk")
			p(class="small") You may relate your chat with a record in the system, such as an Opportunity or Account.
			kt-select(v-if="d_chatCrnt.isHost" id="kt-chat-add-related" ref="kt-select-related"
				p_appEntKey="all" p_noIcon=false p_placeholder="Search/Select a Record to Relate"
				@change="d_okDisabled = Object.keys($event).length==0")
</template>

 <script>

import {Chat} from 'vue-quick-chat';
import 'vue-quick-chat/dist/vue-quick-chat.css';
import io from 'socket.io-client';
import {api_baseURL, userInfo} from "@/utils/ref-data.js";
import {fn_getModal_confirm, fn_tmNameShort, fn_resizeHelper, fn_profilePicURL} from "@/utils/util.js";
import {client_subdomain, fn_get_IdToken} from "@/utils/init.js";

export default {
	name: "kt-chat",
	components: {
		'vue-quick-chat': Chat,
	},
	created() {
		fn_initializeSocket(this);
	},
	beforeDestroy() {
		fn_killSocket(this);
	},
	mounted() {},
	data() {
		let tm = userInfo.getUserInfo().teamMember;
		return {
			d_socket: null,
			d_dfltCP: fn_getDefaultChatProps(),
			d_chatCrnt: {},
			d_chats: [],
			d_myself: {
				id: null, //appUserId set on server side socket connect
				name: fn_tmNameShort(tm.teamMemberName),
				nameFull: tm.teamMemberName,
				// teamMemberId: tm.teamMemberId,
				profilePicture: fn_profilePicURL(tm.teamMemberId),
				isRemoved: null,
			},
			d_okDisabled: true,
			d_connected: null,
		};
	},
	props: {
	},
	computed: {
		c_newMsgCnt() {
			let cnt = this.d_chats.map(x => x.newMsgCnt).reduce((sum, i) => {return sum + (i || 0);}, 0);
			return cnt > 99 ? '99+' : cnt < 1 ? null : cnt;
		},
		c_participants() {
			return this.d_chatCrnt.participants.filter(x => x.id != this.d_myself.id && x.isRemoved != true);
		},
	},
	methods: {
		m_startNewChat(e, relatedRecord) {
			if (e.detail > 1) return;
			fn_clearAddRemoveMsg(this);
			let ncp = new ChatInstance(this, null);
			ncp.isHost = true;
			ncp.participants[0].isHost = true;
			ncp.relatedRecord = relatedRecord || null;
			this.d_chats.push(ncp);
			this.d_chatCrnt = ncp;

			let data = {
				chatId: ncp.chatId,
				relatedRecord
			};
			this.d_socket.emit('startNewChat', data);
		},
		m_changeTitle() {
			let data = {
				chatId: this.d_chatCrnt.chatId,
				chatTitle: this.d_chatCrnt.chatTitle,
			};
			this.d_socket.emit('changeTitle', data);
		},
		m_changeRelated() {
			let data = {
				chatId: this.d_chatCrnt.chatId,
				relatedRecord: this.d_chatCrnt.relatedRecord,
			};
			this.d_socket.emit('changeRelatedRecord', data);
		},
		m_hideChat() {
			// fn_hideChatClass(this);//TBD Animate
			// setTimeout(() => {this.d_chatCrnt = {};}, 0); //TBD Animate

			this.d_chatCrnt = {};
			let data = {
				chatId: this.d_chatCrnt.chatId,
			};
			this.d_socket.emit('lastSeen', data);
		},
		m_openChat(e, c) {
			if (e.detail > 1) return;
			if (c.chatId == this.d_chatCrnt.chatId) return;
			fn_clearAddRemoveMsg(this);

			if (c.isHost && c.participants.length == 0) c.participants.push(this.d_myself);
			this.d_chatCrnt = c;

			c.newMsgCnt = 0;
			let data = {
				chatId: this.d_chatCrnt.chatId,
				isOpen: true,
			};
			this.d_socket.emit('lastSeen', data);
		},
		m_deleteChat() {

			let content = {
				titleText: 'Confirm Leave and Delete Chat',
				message1: 'Are you sure you want to leave and delete this chat?'
			};
			let cm = fn_getModal_confirm(this, content);
			let _this = this;
			_this.$bvModal.msgBoxConfirm(cm.msgVNodes, cm.opt).then(resp => {
				if (!resp) return;

				let data = {
					chatId: _this.d_chatCrnt.chatId,
					appUserId: _this.d_myself.id,
					isRemovedByHost: null,
					noMsg: _this.d_chatCrnt.messages.length == 0,
				};
				_this.d_socket.emit('deleteChat', data);
				fn_spliceById(_this.d_chats, 'chatId', _this.d_chatCrnt.chatId);
				_this.d_chatCrnt = {};
			});
		},
		m_addParticipant(e) {
			if (!e.appUserId) return; //When kt-select clear btn clicked

			let ccps = this.d_chatCrnt.participants;
			let p = ccps.filter(x => x.id == e.appUserId)[0];
			if (!p || p.isRemoved) {
				if (!p) {
					p = {
						id: e.appUserId,
						name: fn_tmNameShort(e.teamMemberName),
						nameFull: e.teamMemberName,
						// teamMemberId: e.teamMemberId,
						profilePicture: fn_profilePicURL(e.profPic ? e.teamMemberId : 0),
						isRemoved: null
					};
					ccps.push(p);
				}
				else if (p.isRemoved) {
					p.isRemoved = null;
					p.isRemovedByHost = null;
				}

				let data = {
					appUserId: e.appUserId, //Added Participant
					chatId: this.d_chatCrnt.chatId,
					chatTitle: this.d_chatCrnt.chatTitle,
					relatedRecord: this.d_chatCrnt.relatedRecord,
					participants: this.d_chatCrnt.participants,
				};
				this.d_socket.emit('addParticipant', data);


				fn_participantAddRemoveMsg(p, this);
			}
			this.$refs['kt-select-participant'].m_clearSelOpt();
		},
		m_removeParticipant(p) {
			let data = {
				chatId: this.d_chatCrnt.chatId,
				appUserId: p.id,
				isRemovedByHost: true,
			};
			this.d_socket.emit('removeParticipant', data); //Remove by host
		},
		m_sendMessage(msg) {
			let data = {chatId: this.d_chatCrnt.chatId, msg, };
			data.msg.participantIds = this.d_chatCrnt.participants.filter(x => !x.isRemoved).map(x => x.id);
			this.d_socket.emit('sendMsg', data);
		},

		m_tryReconn() {
			fn_initializeSocket(this);
		},

		m_addRelated() {
			this.d_okDisabled = true;
			this.$bvModal.show("bm-kt-chat-related");
		},
		m_addRelatedOk(e) {
			let kts = this.$refs['kt-select-related'];
			if (kts.c_isEmpty || kts.c_isInvalid) {
				e.preventDefault();
				return;
			}
			this.d_chatCrnt.relatedRecord = {
				label: kts.d_selOpt.recName,
				href: kts.c_selOptHref,
			};
			this.m_changeRelated();
		},
		m_resizeChat(e) {
			if (e.button != 0) return;

			let $resizer = $(e.target);
			let $tgtElem = $(this.$refs['kt-chat-main']);
			let width = {min: 300};
			let height = {min: 225, inv: true};

			fn_resizeHelper($resizer, $tgtElem, width, height).then(() => {
				this.d_chatCrnt.dim = {W: width.newW, H: height.newH};
			});
		}
	},
	watch: {},
};
class ChatInstance {

	constructor (vc, data) {
		data = data || {};
		// custom
		this.chatId = data.chatId || Math.round((Date.now()) / 1000);
		this.isHost = data.isHost || null;
		this.isRemoved = data.isRemoved || null;
		this.newMsgCnt = data.newMsgCnt || 0;
		this.relatedRecord = data.relatedRecord || null;
		this.dim = {W: '', H: ''};

		//requred
		this.myself = vc.d_myself;
		this.participants = data.participants || [vc.d_myself];
		this.messages = data.messages || [];

		//Optional
		this.chatTitle = data.chatTitle || null;

		this.fn_isOpen = () => {
			return this.chatId == vc.d_chatCrnt.chatId;
		};
	}

	//methods

	fn_img() {
		return (this.participants.filter(x => x.id != this.myself.id && !x.isRemoved)[0] || {}).profilePicture;
	}
	fn_lbl() {
		let chp = this.participants.filter(x => x.id != this.myself.id && !x.isRemoved);
		let len = chp.length;
		return len == 0 ? 'No Participants' : len == 1 ? chp[0].name : chp[0].name + ' +' + (len - 1) + ' more';
	}
	fn_class() {
		return this.isRemoved ? 'removed' : this.participants.filter(x => !x.isRemoved).length < 2 ? 'no-participants' : null;
	}
}
function fn_getDefaultChatProps() {
	return {
		//Required
		colors: {
			header: {
				// bg: 'rgba(79, 164, 255,.0)',
				bg: '#fff'
				// text: '#fff'
			},
			message: {
				myself: {
					bg: 'rgba(79, 164, 255,.3)',
					text: '#212529'
				},
				others: {
					bg: 'rgba(255, 193, 7,.3)',
					text: '#212529'
				},
				messagesDisplay: {
					bg: '#f8f9fa'
				}
			},
			submitIcon: '#4fa4ff',
			submitImageIcon: '#4fa4ff',
		},

		//Optional
		profilePictureConfig: {
			others: true,
			myself: true,
			styles: {
				width: '30px',
				height: '30px',
				borderRadius: '50%'
			}
		},
		timestampConfig: {
			format: 'F',
			relative: false
		},
	};
}

function fn_initializeSocket(vc) {
	fn_killSocket(vc);

	fn_get_IdToken().then(idTkn => {
		fn_initializeSocketMain(vc, idTkn);
	});
}
function fn_initializeSocketMain(vc, idTkn) {
	let url = api_baseURL.slice(0, -6) + '/kt-chat';
	vc.d_socket = io(url, {
		path: '/kt-socket',
		// reconnection: true, //Default = true Applies only if disconnected due to "transport close" or "tranport-error".
		reconnectionAttempts: 10,
		reconnectionDelay: 1000,
		reconnectionDelayMax: 30000,
		extraHeaders: {
			subdomain: client_subdomain,
			"Authorization": "Bearer " + idTkn,
		},
		methods: ["GET"],
		// withCredentials: true,/No need?
	});

	setTimeout(() => {if (vc.d_connected === null) vc.d_connected = false;}, 2000);

	// vc.d_socket.on('connect', () => {});
	let attemptCounter = 0;
	vc.d_socket.io.on('reconnect_attempt', (attempt) => {
		// console.log('Attempting Socket Reconnect ', attempt, attemptCounter, (new Date()).toLocaleTimeString());
		if (attempt == 1) {
			attemptCounter++;
			if (attemptCounter == 2) {
				// console.log('Too Many Attempts, Killing Socket Connection', (new Date()).toLocaleTimeString());
				// fn_killSocket(vc);
				fn_initializeSocket(vc);
			}
		}

	});
	vc.d_socket.io.on('reconnect_failed', () => {
		// console.log('Failed Socket Reconnect. Closing Socket');
		fn_killSocket(vc);
	});

	let timeoutMnl = null;
	vc.d_socket.on('disconnect', (reason) => {
		vc.d_connected = false;
		// console.log('SocketIO Disconnected -- ', reason, (new Date()).toLocaleTimeString());
		if (!/^(io server disconnect|io client disconnect)$/.test(reason)) return;
		clearTimeout(timeoutMnl);
		timeoutMnl = setTimeout(() => {
			if (vc.d_socket) {
				// console.log('Manually Opening Connection - 5 Sec Delay', (new Date()).toLocaleTimeString());
				vc.d_socket.open();
			}
		}, 5000);

	});



	vc.d_socket.on('connected', (data) => {
		// console.log('Socket Connected', (new Date()).toLocaleTimeString());
		attemptCounter = 0;
		vc.d_connected = true;

		vc.d_myself.id = data.appUserId;
		vc.d_chats = [];
		data.chats.forEach(ch => {
			let chInst = new ChatInstance(vc, ch);
			vc.d_chats.push(chInst);
		});
	});
	vc.d_socket.on('newChatStarted', (chatId) => {
		vc.d_chatCrnt.chatId = chatId;
	});
	vc.d_socket.on('titleChanged', (data) => {
		fn_getChat(data.chatId, vc).chatTitle = data.chatTitle;
	});
	vc.d_socket.on('relatedRecordChanged', (data) => {
		fn_getChat(data.chatId, vc).relatedRecord = data.relatedRecord;
	});
	vc.d_socket.on('addedToChat', (data) => {
		//Self-Added by Host
		let ch = fn_getChat(data.chatId, vc);
		if (ch) {//Previously Added
			ch.isRemoved = null;
			ch.participants = data.participants;
			if (ch.fn_isOpen()) fn_participantAddRemoveMsg(vc.d_myself, vc);
		}
		else {
			let newch = new ChatInstance(vc, data);
			newch.isRemoved = null;
			newch.messages = data.messages;
			vc.d_chats.push(newch);
		}


	});
	vc.d_socket.on('removedFromChat', (chatId) => {
		//Self-Removed by Host
		let ch = fn_getChat(chatId, vc) || {};
		ch.isRemoved = true;
		let p = fn_getParticipant(vc.d_myself.id, ch);
		p.isRemoved = true;
		p.isRemovedByHost = true;

		if (ch.fn_isOpen()) fn_participantAddRemoveMsg(p, vc);
	});

	vc.d_socket.on('participantAdded', (data) => {
		//Others-Added By Host
		let ch = fn_getChat(data.chatId, vc);
		let p = fn_getParticipant(data.participant.id, ch);
		if (p) {
			p.isRemoved = null;
			p.isRemovedByHost = null;
		}
		else {
			ch.participants.push(data.participant);
		}
		fn_participantAddRemoveMsg((p || data.participant), vc);
	});
	vc.d_socket.on('participantRemoved', (data) => {
		// Others-Removed by Host or Left on Own (Including Host)
		let ch = fn_getChat(data.chatId, vc) || {};
		let p = fn_getParticipant(data.appUserId, ch);
		if (!p) return;
		p.isRemoved = true;
		p.isRemovedByHost = data.isRemovedByHost;

		if (ch.fn_isOpen()) fn_participantAddRemoveMsg(p, vc);
		//Keep in Participants Array - or else error (due to existing messages)	
	});

	vc.d_socket.on('msgRecieved', (data) => {
		let ch = fn_getChat(data.chatId, vc);
		ch.messages.push(data.msg);

		if (ch.chatId != vc.d_chatCrnt.chatId) {
			ch.newMsgCnt++;
			fn_newNotifClass(vc);
		}
	});

}
function fn_killSocket(vc) {
	let io = vc.d_socket;
	if (!io) return;
	io.disconnect();
	io.close();
	io.off();
	vc.d_socket = null;
}

function fn_getChat(chatId, vc) {
	return vc.d_chats.filter(x => x.chatId == chatId)[0];
}
function fn_getParticipant(id, chat) {
	return chat.participants.filter(x => x.id == id)[0];
}
function fn_spliceById(array, idKey, idVal) {
	if (!array) return;
	let ix = array.map(x => x[idKey]).indexOf(idVal);
	array.splice(ix, 1);
}
function fn_newNotifClass(vc) {
	let $n = $(vc.$refs['notification']);
	$n.toggleClass('new');
	setTimeout(() => {
		$n.toggleClass('new');
	}, 1000);
}
// function fn_hideChatClass(vc) {
// 	let $ktcm = $(vc.$refs['kt-chat-main']);
// 	$ktcm.toggleClass('hide');
// 	setTimeout(() => {
// 		$ktcm.toggleClass('hide');
// 	}, 1000);
// }

function fn_participantAddRemoveMsg(p, vc) {

	let rbh = p.isRemovedByHost;
	let r = p.isRemoved;
	let msg;
	if (p.id == vc.d_myself.id) {
		msg = 'You are' + (rbh || r ? ' removed from' : ' added to');
	}
	else {
		msg = p.name + (rbh ? ' is removed from' : r ? ' left' : ' is added to');
	}


	let $msg = $('<div>', {class: "message-info"}).append(msg + ' the chat');

	let $cmd = $(vc.$refs['kt-chat-main']).find('.container-message-display');
	$cmd.append($msg);
}
function fn_clearAddRemoveMsg(vc) {
	$(vc.$refs['kt-chat-main']).find('.container-message-display').empty();
}

</script>


<style lang="less">
#kt-chat {
	// display: none;
	position: fixed;
	bottom: 0;
	left: 0;
	border-right: solid 0.1em #dee2e6;
	width: 161px;
	height: 50px;
	background-color: #ffffff;
	z-index: 100;

	#side-nav-controls {
		// border: solid 0.1em red;
		position: relative;
		margin-top: 10px;

		button.dropdown-toggle {
			font-size: 0.95em;
			width: 7em;
			// padding: 0em 0.5em;
		}
		ul.dropdown-menu {
			width: 200px;
			height: 18em;
			padding: 0.2em 0em;
			> div:first-child {
				height: 1.8em;
				text-align: center;
				border-bottom: solid 0.1em #6c757d;
				.btn-start-new-chat {
					font-size: 0.9em;
					padding: 0em 0.2em;
					// color: #4fa4ff;
					// &:hover {
					// 	// background-color: #e9ecef;
					// }
				}
			}
			> div.chats {
				height: 15.5em;
				overflow-y: auto;
				padding: 0 0.2em;

				> div.chat {
					position: relative;
					border: solid 0.1em #adb5bd;
					border-radius: 0.2em;
					padding: 0.2em 0.4em;
					margin: 0.2em 0;
					cursor: pointer;
					line-height: 1em;
					min-height: 2em;
					> div {
						display: flex;
						> div:first-child img {
							border-radius: 1em;
							margin-right: 0.5em;
						}
						> div:nth-child(2) > span {
							display: inline-block;
							width: 100%;
							&:first-child {
								font-size: 0.8em;
							}
							&:nth-child(2) {
								font-size: 0.75em;
								///***
								// margin: auto 0;
								-ms-word-break: break-all;
								word-break: break-all;
								overflow: hidden;
								text-overflow: ellipsis;
								display: -webkit-box;
								-webkit-line-clamp: 3; /* number of lines to show */
								-webkit-box-orient: vertical;
							}
						}
					}
					.new-msgs.kt-bbl {
						position: absolute;
						top: 0.3em;
						right: 0.3em;

						background-color: #fd7e14;
						font-size: 0.8em;
					}

					&:hover {
						background-color: #f8f9fa;
					}
					&.open {
						// background-color: #f8f9fa;
						background-color: rgba(79, 164, 255, 0.2);
						> div span:first-child {
							font-weight: bold;
							// font-size: 0.95em;
						}
					}
				}
				> div.no-chats {
					text-align: center;
					padding: 1em 0.5em;
				}
				> div.no-connection {
					text-align: center;
					padding: 0.5em 0.5em;
					line-height: 1.2em;
					font-size: 0.9em;
					> svg {
						color: #dc3545;
					}
					span.btn {
						font-size: 0.9em;
						padding: 0.3em 0.2em;
					}
				}
			}
		}

		span.notification {
			position: absolute;
			right: 1.2em;
			top: -0.8em;
			background-color: #fd7e14;
			font-size: 0.75em;
			z-index: 10;

			line-height: 1em;
			padding: 0.2em;
			min-width: 1.75em;
			border-radius: 1em;

			color: #ffffff;
			cursor: default;

			border: solid 0.15em #ced4da;
		}

		@keyframes newNotif {
			from {
				transform: scale(1.4);
			}

			to {
				transform: scale(1);
			}
		}

		span.notification.new {
			animation: newNotif 0.6s ease 0s 1;
		}
	}

	#kt-chat-main {
		position: fixed;
		bottom: 1em;
		left: 170px;

		width: 300px;
		height: 450px;
		max-height: calc(100vh - 1em);
		max-width: calc(90vw - 140px);

		> div.resizer {
			// border: solid 0.1em blue;
			position: absolute;
			right: 0.15em;
			top: -0.05em;
			cursor: nesw-resize;
			opacity: 0.2;
			font-size: 0.9em;
			line-height: 0.9em;
			&:hover {
				opacity: unset;
				color: #4fa4ff;
			}
			> svg {
				transform: rotate(-45deg);
				pointer-events: none;
			}
			&.resizing {
				// border: solid 0.1em blue;
				width: 800px;
				height: 800px;
				right: -393px;
				top: -401px;
				z-index: 500;
				> svg {
					margin-top: 50%;
				}
			}
		}

		&.no-participants,
		&.removed {
			.participants > span:first-child {
				opacity: 0.5;
				// text-decoration: line-through;
			}
			.thum-container,
			.message-text {
				opacity: 0.6;
			}
			.message-text-box {
				background-color: #f8f9fa;
				font-size: 0.8em;
				// padding-top: 0.5em;

				&::after {
					display: block;
					text-align: left;
				}
			}
			.message-input,
			.container-send-message {
				display: none;
			}
		}

		&.no-participants .message-text-box::after {
			content: "You are the only participant in the chat";
		}
		&.removed .message-text-box::after {
			content: "You have been removed from the chat";
		}
	}

	.quick-chat-container {
		border: solid 0.15em #adb5bd;
		box-shadow: 0em 0.05em 0.1em 0.15em #e9ecef;

		border-top-right-radius: 0 !important;
		.header-container {
			// position: relative;
			display: flex;
			flex-wrap: wrap;
			text-align: left;
			padding: 0.5em;
			padding-bottom: 0.2em;
			height: unset;
			z-index: unset;
			border-bottom: solid 0.1em #adb5bd;

			> div.title {
				flex-grow: 1;
				input {
					height: 1.8em;
					font-size: 0.9em;
					padding: 0 0.4em;
				}
			}
			> div.buttons {
				padding-left: 0.2em;
				.btn {
					line-height: 1em;
					padding: 0.1em 0.2em;
					margin: 0em 0.2em;
					font-size: 0.9em;
					color: #212529;
					background-color: #e9ecef;
					border-radius: 1em;
					opacity: 0.4;
					&:hover {
						opacity: unset;
					}
				}
			}

			.participants {
				width: 100%; //Important
				min-height: 2em;
				font-size: 0.8em;
				border: solid 0.1em #adb5bd;
				border-radius: 0.25em;
				margin-top: 0.5em;
				padding: 0.2em;
				> span {
					display: inline-block;
					padding: 0 0.2em;
					cursor: default;
					// line-height: 1em;
					&:not(:last-of-type)::after {
						content: ",";
					}
					.btn-remove {
						font-size: inherit;
					}
				}
				> div.kt-select {
					font-size: initial;
					margin: 0.2em;
					div.input {
						padding-top: 0em;
						padding-bottom: 0em;
					}
					div.opt-cont {
						font-size: 0.9em;
					}
				}
			}
			.related-record {
				a,
				.btn-add-related {
					font-size: 0.8em;
					padding: 0;
				}
				.btn-remove {
					font-size: 0.8em;
					margin-left: 0.2em;
				}
			}

			.participants .btn-remove,
			.related-record .btn-remove {
				line-height: 1em;
				color: #dc3545;
				padding: 0;
				opacity: 0.6;
				&:hover {
					opacity: unset;
				}
			}
		}

		.container-message-display {
			overflow-y: scroll;
			&::-webkit-scrollbar {
				width: 0.4em;
				// background-color: #e9ecef;
			}
			&::-webkit-scrollbar-thumb {
				border-radius: 0.5em;
				background-color: #ced4da;
			}
		}
		.message-container {
			.message-text {
				padding: 0.2em 0.5em;
				margin: 0;
				.message-username {
					font-size: 0.8em;
				}
			}
			.message-timestamp {
				max-width: unset;
			}
		}
		.message-info {
			font-size: 0.8em;
			// color: #28a745;
			padding: 0 1em;
		}
		.container-message-manager {
			padding: 0.6em 0.4em;
			position: relative;
			.message-text-box {
				padding: 0.2em 0.3em;
				border: solid 0.1em #adb5bd;
				border-radius: 0.15em;
				height: 100%;
				max-width: calc(100% - 28px);
			}
			.container-send-message {
				position: absolute;
				right: 0.4em;
				padding: 0em;
				margin: 0;

				&:nth-child(2) {
					top: 10%;
				}
				&:nth-child(3) {
					top: 50%;
				}
			}
		}
	}
}

#kt-chat.not-connected {
	#side-nav-controls {
		button.dropdown-toggle {
			opacity: 0.6;
		}

		span.notification {
			display: none;
		}
		span.no-connection {
			position: absolute;
			right: 1em;
			top: -0.5em;
			line-height: 1em;
			color: #dc3545;
			cursor: default;
			z-index: 10;
		}
	}

	.quick-chat-container {
		.header-container > div:not(.buttons),
		.container-message-manager {
			pointer-events: none;
			opacity: 0.5;
		}
	}
}

#kt-chat {
	@media (max-width: 576px) {
		bottom: 1em;
		left: 1em;
		width: unset;
		height: unset;
		border-right: unset;
		// background-color: none;
		#side-nav-controls {
			margin-top: unset;
			button.dropdown-toggle {
				font-size: 1.2em;
				width: unset;
				box-shadow: 0 0 0.2em 0.2em #4fa4ff4d;
				// box-shadow: 0 0 0.2em 0.15em #ced4da;
				span {
					display: none;
				}
			}
			span.notification {
				right: -1em;
			}
		}

		#kt-chat-main {
			left: 15px;
			bottom: 50px;
			height: calc(90vh - 50px);
			width: calc(100vw - 30px);
			max-width: calc(100vw - 30px);
		}
	}
}
.side-nav-collapsed #kt-chat {
	background-color: #e9ecef;
	width: 41px;
	padding: 0 0.5em;

	#side-nav-controls {
		button.dropdown-toggle {
			background-color: #ffffff;
			width: unset;
			span {
				display: none;
			}
		}
		> .dropdown.show > button.btn,
		> .dropdown > button:hover.btn {
			background-color: #4fa4ff;
		}

		span.no-connection,
		span.notification {
			right: -1em;
		}
	}
	#kt-chat-main {
		left: 50px;
		max-width: calc(90vw - 20px);
	}
	@media (max-width: 576px) {
		background-color: unset;
		left: 0.5em;

		#kt-chat-main {
			left: 15px;
			max-width: calc(100vw - 30px);
		}
	}
}

#bm-kt-chat-related {
	div.options-container {
		// font-size: 0.9em;
		// font-size: 1em;
		// div.grouped {
		// 	font-size: 0.9em;
		// }
		div.rec-type {
			font-size: 0.8em;
		}
	}
	.modal-footer {
		text-align: left;
		flex-direction: row-reverse;
		.btn {
			padding: 0 0.4em;
		}
	}
}
</style>

